import { useContext } from "react";
import { AppContext } from "../../contexts/app";
import { ACTIONS } from "../../contexts/app/actions";

const useMusic = () => {
  const { state, dispatch } = useContext(AppContext);
  const { isPlaying, song, volume } = state.music;

  const changePlaying = () => {
    dispatch({ type: ACTIONS.SET_PLAYING });
  };

  const setSong = (song) => {
    dispatch({ type: ACTIONS.SET_SONG, value: song });
  };

  const setVolume = (volume) => {
    dispatch({ type: ACTIONS.SET_VOLUME, value: volume });
  };

  return { isPlaying, song, volume, changePlaying, setSong, setVolume };
};

export default useMusic;
